/* ============================================================
   SNKRS FAQ – FINAL STABLE VERSION
   - Mobile: native Momentum-Scroll (keine eigene Physik)
   - Desktop: Drag mit Maus (festhalten + ziehen links/rechts)
   - Bubbles klickbar (smooth scroll zu H3)
   - FAQ Accordion mit Plus/Minus
============================================================ */

document.addEventListener('DOMContentLoaded', function() {

  /* ---------------------------------------
      1) SMOOTH SCROLL VIA BUBBLE BUTTONS
  --------------------------------------- */
  const bubbleButtons = document.querySelectorAll('.faq-bubbles button');
  const headings = document.querySelectorAll('.footer-faq h3');

  bubbleButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const targetText = btn.dataset.target.trim().toLowerCase();

      for (const h3 of headings) {
        if (h3.textContent.trim().toLowerCase() === targetText) {
          const yOffset = -80; // Abstand nach oben
          const y = h3.getBoundingClientRect().top + window.pageYOffset + yOffset;

          window.scrollTo({
            top: y,
            behavior: 'smooth'
          });
          break;
        }
      }
    });
  });



  /* ---------------------------------------
      2) FAQ ACCORDION (Plus/Minus)
  --------------------------------------- */
  const faqQuestions = document.querySelectorAll('.footer-faq .faq-question');

  faqQuestions.forEach(btn => {
    const answer = btn.nextElementSibling;
    const verticalBar = btn.querySelector('.faq-icon .vertical');

    btn.addEventListener('click', () => {

      // Wenn dieses offen ist → schließen
      if (answer.classList.contains('open')) {
        answer.classList.remove('open');
        answer.style.maxHeight = '0px';
        answer.style.opacity = '0';
        answer.style.paddingTop = '0';
        answer.style.paddingBottom = '0';
        verticalBar.style.transform = 'translateX(-50%) scaleY(1)'; // Plus anzeigen
        return;
      }

      // Alle anderen offenen Antworten schließen
      document.querySelectorAll('.footer-faq .faq-answer.open').forEach(openAns => {
        openAns.classList.remove('open');
        openAns.style.maxHeight = '0px';
        openAns.style.opacity = '0';
        openAns.style.paddingTop = '0';
        openAns.style.paddingBottom = '0';

        const vb = openAns.previousElementSibling.querySelector('.faq-icon .vertical');
        if (vb) {
          vb.style.transform = 'translateX(-50%) scaleY(1)';
        }
      });

      // Dieses öffnen
      answer.classList.add('open');
      answer.style.display = 'block';
      answer.style.maxHeight = answer.scrollHeight + 'px';
      answer.style.opacity = '1';
      answer.style.paddingTop = '12px';
      answer.style.paddingBottom = '12px';

      // Minus anzeigen
      verticalBar.style.transform = 'translateX(-50%) scaleY(0)';
    });
  });



  /* ---------------------------------------
      3) BUBBLE-DRAG (Desktop ONLY)
      - Mobile nutzt native Momentum
  --------------------------------------- */
  const box = document.getElementById('faqBubbleBox');
  if (!box) return;

  const isTouchDevice =
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0;

  // Auf Touch-Geräten: NUR native Scroll → am smoothsten
  if (isTouchDevice) {
    // nichts weiter tun, CSS: overflow-x: auto; -webkit-overflow-scrolling: touch;
    return;
  }

  // Desktop: Drag mit Maus
  let isDragging = false;
  let startX = 0;
  let scrollStart = 0;
  let dragged = false;

  box.addEventListener('mousedown', e => {
    isDragging = true;
    dragged = false;
    startX = e.pageX;
    scrollStart = box.scrollLeft;
    box.classList.add('is-dragging');
  });

  box.addEventListener('mousemove', e => {
    if (!isDragging) return;

    e.preventDefault(); // verhindert Text-Selection
    const dx = e.pageX - startX;

    if (Math.abs(dx) > 5) {
      dragged = true; // es war wirklich ein Drag, kein Klick
    }

    box.scrollLeft = scrollStart - dx;
  });

  ['mouseup', 'mouseleave'].forEach(ev => {
    box.addEventListener(ev, () => {
      isDragging = false;
      box.classList.remove('is-dragging');
    });
  });

  // Klick-Unterdrückung, wenn vorher gezogen wurde
  box.addEventListener('click', e => {
    if (dragged) {
      e.preventDefault();
      e.stopPropagation();
      dragged = false;
    }
  }, true);

});
